import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, WithTranslation } from "react-i18next";
import { faMailbox,faBell,faMessage } from "@fortawesome/pro-light-svg-icons";
import { faMailbox as faSolidMailbox,faBell as faSolidBell,faMessage as faSolidMessage } from "@fortawesome/pro-solid-svg-icons";
interface GigRequestReConfirmedAlertsProps extends WithTranslation{ 
    data:any;
    gigRequestReConfirmNotificationService:(data:any,notificationType:string)=>void
}

interface GigRequestReConfirmedAlertsState { }

class GigRequestReConfirmedAlerts extends Component<GigRequestReConfirmedAlertsProps, GigRequestReConfirmedAlertsState> {
    formatDateDDMMtoMMDD = (dateTimeStr:string) => {
        if (!dateTimeStr) return "";
        // Expected format: "DD/MM/YYYY HH:mm:ss"
        const [datePart] = dateTimeStr.split(" ");
        const [dd, mm, yyyy] = datePart.split("/");
        return `${mm}/${dd}/${yyyy}`;
    };
    render() {
        let latestDateTime = this.props.data.notificationLatestDateTime? this.formatDateDDMMtoMMDD(this.props.data.notificationLatestDateTime): "";

        return (
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    {this.props.data.requestStatus.value === "Booked" && this.props.data.emailNotificationDateTime? <FontAwesomeIcon icon={faSolidMailbox} className="btn icon-btn"/>:
                    this.props.data.requestStatus.value === "Booked" && !this.props.data.emailNotificationDateTime?
                    <FontAwesomeIcon icon={faMailbox} className="btn icon-btn" onClick={()=>this.props.gigRequestReConfirmNotificationService(this.props.data,"2")}/>:
                    <FontAwesomeIcon icon={faMailbox} className="btn icon-btn disabled"/>}

                    {/* {this.props.data.requestStatus.value === "Booked" && this.props.data.notificationDateTime? <FontAwesomeIcon icon={faSolidBell} className="btn icon-btn"/>:
                    this.props.data.requestStatus.value === "Booked" && !this.props.data.notificationDateTime?
                    <FontAwesomeIcon icon={faBell} className="btn icon-btn" onClick={()=>this.props.gigRequestReConfirmNotificationService(this.props.data,"3")}/>:
                    <FontAwesomeIcon icon={faBell} className="btn icon-btn disabled"/>} */}

                    {/* Bug 20884: UI - Reconfirm Payload Changes & Disable Mobile Notification */}
                    <FontAwesomeIcon icon={faBell} className="btn icon-btn disabled"/>

                    {this.props.data.requestStatus.value === "Booked" && this.props.data.textNotificationDateTime? <FontAwesomeIcon icon={faSolidMessage} className="btn icon-btn"/>:
                    this.props.data.requestStatus.value === "Booked" && !this.props.data.textNotificationDateTime?
                    <FontAwesomeIcon icon={faMessage} className="btn icon-btn" onClick={()=>this.props.gigRequestReConfirmNotificationService(this.props.data,"4")}/>:
                    <FontAwesomeIcon icon={faMessage} className="btn icon-btn disabled"/>}
                </div>
                <span>{latestDateTime}</span>
            </div>
        );
    }
}

export default withTranslation()(GigRequestReConfirmedAlerts);
